export const getEntityCount = (state, entityType) => state.pagination[entityType].entityCount;



// WEBPACK FOOTER //
// ./app/selectors/pagination-selectors.js